export const CURRENCIES = [
  { code: 'USD', symbol: '$', rate: 1, locale: 'en-US' },
  { code: 'GBP', symbol: '£', rate: 0.79, locale: 'en-GB' },
  { code: 'EUR', symbol: '€', rate: 0.92, locale: 'de-DE' },
  { code: 'ZAR', symbol: 'R', rate: 18.4, locale: 'en-ZA' },
];

// Converts a USD price string such as "From $15,000" into the selected currency.
// Non-numeric values (e.g. "On Application") are returned untouched.
export function convertPrice(text = '', currency) {
  const match = text.match(/\$([\d,]+)/);
  if (!match) return text;
  const usd = Number(match[1].replace(/,/g, ''));
  const converted = Math.round((usd * currency.rate) / 100) * 100;
  return text.replace(match[0], `${currency.symbol}${converted.toLocaleString('en-US')}`);
}